
(function(){
  var root=document.getElementById('agc-landing'); if(!root) return;
  /* nav: barra única compartida (agc-nav.js la maneja sola) */
  /* PDP EMBED: si el landing NO es fixed (embebido en la PDP → scrollea la ventana), usar window scroll. SCY()=scroll dentro del landing (0 en su top). Homepage sin cambio. */
  var EMBED = !!document.getElementById('agc-cfg');  /* PDP de ducha: el landing convive con el configurador */
  var SCEL = EMBED ? window : root;
  function SCY(){ return EMBED ? Math.max(0, -root.getBoundingClientRect().top) : root.scrollTop; }

  /* El webview de TikTok SECUESTRA cualquier video que se reproduzca y lo abre en el player fullscreen
     (ignora playsinline). → en TikTok NO reproducimos ningún video decorativo (helix + scards): solo
     poster/estático. Pedro 2026-06-23. */
  var TT = /Bytedance|musical_ly|trill|tiktok/i.test(navigator.userAgent || '');

  /* autoplay rescue: in-app de Meta/IG/FB a veces bloquea autoplay aun con muted (NO aplicar en TikTok).
     En el primer gesto del usuario reintentamos play() en todos los videos visibles. */
  if(!TT){ (function(){ var done=false;
    function kick(){ if(done) return; done=true;
      root.querySelectorAll('video').forEach(function(v){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); });
      ['touchstart','pointerdown','click','scroll'].forEach(function(ev){ window.removeEventListener(ev,kick); });
    }
    ['touchstart','pointerdown','click','scroll'].forEach(function(ev){ window.addEventListener(ev,kick,{passive:true}); });
  })(); }

  /* reveal on scroll */
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); },{threshold:.18});
  root.querySelectorAll('.reveal').forEach(function(e){ io.observe(e); });

  /* fill-text: ver IIFE "FILL SEQUENCE" abajo (pinned: ilumina → negro → split) */

  /* n-cards: una activa */
  root.querySelectorAll('#ncards [data-nc]').forEach(function(c){
    c.addEventListener('click',function(){ root.querySelectorAll('#ncards [data-nc]').forEach(function(x){x.classList.remove('on');}); c.classList.add('on'); });
  });

  /* accordion details + FAQ (un solo abierto) */
  function acc(sel){ root.querySelectorAll(sel).forEach(function(it){ var h=it.querySelector('.accitem-h,.qitem-h'); h.addEventListener('click',function(){ var was=it.classList.contains('on'); it.parentNode.querySelectorAll('.on').forEach(function(o){o.classList.remove('on');}); it.classList.toggle('on',!was); }); }); }
  acc('[data-acc]'); acc('[data-q]');

  /* colorpicker */
  var swImg=root.querySelector('#swImg'), swCap=root.querySelector('#swCap');
  root.querySelectorAll('.sw').forEach(function(s){
    s.addEventListener('click',function(){ root.querySelectorAll('.sw').forEach(function(x){x.classList.remove('on');}); s.classList.add('on'); swImg.style.opacity=0; setTimeout(function(){
  var root=document.getElementById('agc-landing'); if(!root) return; swImg.src=s.dataset.img; swImg.style.opacity=1; swCap.textContent=s.dataset.sw; },220); });
  });

  /* breadcrumb por sección */
  var crumb=root.querySelector('#crumb');
  var labels=[['.hero','Overview / Shower'],['.fill','The truth / The water'],['.ncards','Benefits'],['.details','The system'],['.parallax','ZERO'],['.feat','How it works'],['.colors','Finishes'],['.videoband','The movement'],['.box','Your delivery'],['.faq','Questions'],['.final','Start']];
  var secs=labels.map(function(l){ return [document.querySelector(l[0]),l[1]]; }).filter(function(x){return x[0];});
  function crumbUpd(){ var y=SCY()+innerHeight*0.5, cur=secs[0][1]; secs.forEach(function(s){ if(s[0].offsetTop<=y) cur=s[1]; }); crumb.textContent=cur; }
  SCEL.addEventListener('scroll',crumbUpd,{passive:true}); crumbUpd();

  /* anchors dentro del takeover → scroll del root */
  root.querySelectorAll('a[href^="#"]').forEach(function(a){ a.addEventListener('click',function(e){ var t=root.querySelector(a.getAttribute('href')); if(t){ e.preventDefault(); if(EMBED) window.scrollTo({top:t.getBoundingClientRect().top+(window.pageYOffset||0),behavior:'smooth'}); else root.scrollTo({top:t.offsetTop,behavior:'smooth'}); } }); });

  /* ░░ DISSECTION: ahora fusionada dentro del IIFE "FILL + DISSECTION" (emerge desde el split, misma pantalla) ░░ */

  /* ░░ INTRO: helix de agua táctil (shader aprobado). Scrollea normal; la disolución a negro aparece SOLO al scrollear ░░ */
  (function(){
    var intro=root.querySelector('#intro'); if(!intro) return;

    /* — disolución a tinta ligada al scroll: 0 al rest (look airoso) → 1 conforme bajas — */
    var grad=intro.querySelector('.intro-grad');
    if(grad){
      var graf=null;
      function gupd(){ graf=null;
        var h=intro.offsetHeight||innerHeight;
        grad.style.opacity=Math.max(0,Math.min(1, SCY()/(h*0.55)));
      }
      SCEL.addEventListener('scroll',function(){ if(!graf) graf=requestAnimationFrame(gupd); },{passive:true});
      addEventListener('resize',function(){ if(!graf) graf=requestAnimationFrame(gupd); });
      gupd();
    }

    /* — capa de agua: video pre-renderizado + shader WebGL táctil (valores EXACTOS del prototipo aprobado) — */
    var cv=root.querySelector('#introHelix'), vid=root.querySelector('#introHelixVid'), poster=root.querySelector('#introHelixPoster');
    var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse=matchMedia('(pointer: coarse)').matches || innerWidth<768;

    if(TT){ cv.style.display='none'; if(vid){ vid.style.display='none'; try{ vid.removeAttribute('data-lazyvid'); }catch(e){} } if(poster) poster.style.display='block'; return; }  /* TikTok: solo poster (su webview abre el video en fullscreen) + sacar el helix del lazyvid para no bajarlo */
    if(reduce){ cv.style.display='none'; poster.style.display='block'; return; }   /* accesibilidad: poster estático */
    if(vid){ try{ vid.load(); }catch(e){} vid.play().catch(function(){}); }        /* preload=none → forzar descarga + autoplay */
    if(coarse){ cv.style.display='none'; vid.style.display='block'; return; }       /* mobile/touch: solo video (tiene su propio poster) */

    var gl=null;
    try{ gl=cv.getContext('webgl',{antialias:true,alpha:false})||cv.getContext('experimental-webgl'); }catch(e){}
    if(!gl){ cv.style.display='none'; vid.style.display='block'; return; }          /* sin WebGL: solo video */

    /* RED DE SEGURIDAD (Pedro 2026-06-23): en la ruta WebGL la textura arranca en un placeholder gris
       (línea ~135). Si el video NO entrega frames — típico en incógnito: caché frío + autoplay con MEI 0 —
       la textura se queda gris para siempre. Si en 3.5s no hay frames, o el video falla, mostrar el poster. */
    if(vid && poster){
      vid.addEventListener('error', function(){ cv.style.display='none'; poster.style.display='block'; }, {once:true});
      setTimeout(function(){ if(vid.readyState < 2){ cv.style.display='none'; poster.style.display='block'; } }, 3500);
    }

    /* shaders — fragment COPIADO VERBATIM del prototipo aprobado (helix-touch.html) */
    var VS='attribute vec2 aPos; varying vec2 vUv; void main(){ vUv=aPos*0.5+0.5; gl_Position=vec4(aPos,0.0,1.0); }';
    var FS=[
      'precision highp float;',
      'varying vec2 vUv;',
      'uniform sampler2D uTex;',
      'uniform vec2  uMouse, uRes, uTexRes;',
      'uniform float uTime, uInten;',
      'void main(){',
      '  float sA = uRes.x / uRes.y;',
      '  float tA = uTexRes.x / uTexRes.y;',
      '  vec2 uv = vUv;',
      '  if (sA > tA) uv.y = (vUv.y - 0.5) * (tA / sA) + 0.5;',
      '  else         uv.x = (vUv.x - 0.5) * (sA / tA) + 0.5;',
      '  vec2 d = vUv - uMouse; d.x *= sA;',
      '  float dist = length(d);',
      '  float wave = sin(dist * 44.0 - uTime * 5.0) * exp(-dist * 7.0);',
      '  float amp  = 0.009 + uInten * 0.055;',
      '  vec2  dir  = normalize(d + 1e-5);',
      '  vec2  off  = dir * wave * amp;',
      '  float ca = (0.0035 + uInten * 0.012) * wave;',
      '  vec2  cd = dir * ca;',
      '  float r = texture2D(uTex, uv + off + cd).r;',
      '  float g = texture2D(uTex, uv + off     ).g;',
      '  float b = texture2D(uTex, uv + off - cd).b;',
      '  float spec = smoothstep(0.6, 1.0, wave) * (0.10 + uInten*0.25) * exp(-dist*6.0);',
      '  gl_FragColor = vec4(vec3(r,g,b) + spec, 1.0);',
      '}'
    ].join('\n');
    function sh(type,src){ var s=gl.createShader(type); gl.shaderSource(s,src); gl.compileShader(s); return s; }
    var prog=gl.createProgram();
    gl.attachShader(prog,sh(gl.VERTEX_SHADER,VS)); gl.attachShader(prog,sh(gl.FRAGMENT_SHADER,FS));
    gl.linkProgram(prog); gl.useProgram(prog);

    var quad=gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER,quad);
    gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1, 1,-1, -1,1, -1,1, 1,-1, 1,1]),gl.STATIC_DRAW);
    var aPos=gl.getAttribLocation(prog,'aPos'); gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos,2,gl.FLOAT,false,0,0);

    var uTex=gl.getUniformLocation(prog,'uTex'), uMouse=gl.getUniformLocation(prog,'uMouse'),
        uTime=gl.getUniformLocation(prog,'uTime'), uInten=gl.getUniformLocation(prog,'uInten'),
        uRes=gl.getUniformLocation(prog,'uRes'), uTexRes=gl.getUniformLocation(prog,'uTexRes');

    var tex=gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D,tex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);   /* equivale al flipY=true de THREE.VideoTexture */
    gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array([200,210,220,255]));
    gl.uniform1i(uTex,0);
    gl.uniform2f(uTexRes,1080,1920);

    var dpr=Math.min(devicePixelRatio,2);
    function size(){ var w=cv.clientWidth, h=cv.clientHeight; cv.width=Math.round(w*dpr); cv.height=Math.round(h*dpr);
      gl.viewport(0,0,cv.width,cv.height); gl.uniform2f(uRes,w,h); }
    size(); addEventListener('resize',size);

    /* cursor: target + suavizado + velocidad (constantes EXACTAS del prototipo) */
    var tX=0.5,tY=0.5, mX=0.5,mY=0.5, inten=0, uIntenVal=0;
    function setPointer(x,y){ tX=x/innerWidth; tY=1.0-y/innerHeight; }
    addEventListener('pointermove',function(e){
      var dx=e.clientX/innerWidth - tX, dy=(1.0-e.clientY/innerHeight) - tY;
      inten=Math.min(1.0, inten + Math.hypot(dx,dy)*6.0);
      setPointer(e.clientX,e.clientY);
    },{passive:true});
    addEventListener('pointerdown',function(){ inten=1.0; });

    var t0=performance.now(), active=false;
    function loop(){
      if(!active) return;
      requestAnimationFrame(loop);
      gl.uniform1f(uTime,(performance.now()-t0)/1000);
      mX += (tX-mX)*0.12; mY += (tY-mY)*0.12;
      inten *= 0.93;
      uIntenVal += (inten - uIntenVal)*0.2;
      gl.uniform2f(uMouse,mX,mY);
      gl.uniform1f(uInten,uIntenVal);
      if(vid.readyState>=2){
        gl.bindTexture(gl.TEXTURE_2D,tex);
        gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,vid);
        if(vid.videoWidth) gl.uniform2f(uTexRes,vid.videoWidth,vid.videoHeight);
      }
      gl.drawArrays(gl.TRIANGLES,0,6);
    }
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){
      if(e.isIntersecting && !active){ active=true; size(); requestAnimationFrame(loop); }
      else if(!e.isIntersecting){ active=false; }
    }); },{threshold:.01});
    io.observe(intro);
  })();

  /* ░░ ROTATING WORD — "Adiós cloro/metales/…" swap nivel Apple (blur + cross-fade + width tween) ░░ */
  (function(){
    var host=root.querySelector('#rotWord'); if(!host) return;
    /* alterna contaminante → problema de piel/cabello → contaminante → … (dinámico) */
    var words=['chlorine','dryness','metals','frizz','limescale','itch','hard water','tightness'];
    var cur=host.querySelector('.rot-w'), i=0;
    function setW(el){ host.style.width=el.offsetWidth+'px'; }
    setW(cur);
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ setW(cur); });
    addEventListener('resize',function(){ setW(cur); });
    if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;   /* accesibilidad: sin rotación */

    function tick(){
      i=(i+1)%words.length;
      var next=document.createElement('span');
      next.className='rot-w enter';
      next.textContent=words[i];
      host.appendChild(next);
      host.style.width=next.offsetWidth+'px';          /* el ancho se desliza al de la nueva palabra */
      var old=cur;
      old.classList.add('out');                         /* sale: blur + fade + drift arriba */
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ next.classList.remove('enter'); }); }); /* entra: nítida desde abajo */
      cur=next;
      setTimeout(function(){ if(old.parentNode) old.parentNode.removeChild(old); }, 800);
    }
    setInterval(tick, 1800);
  })();

  /* ░░ STACK CARDS — play/pause de videos según visibilidad (perf) ░░ */
  (function(){
    if(TT) return;   /* TikTok: no autoplay de videos del stack (su webview los abre en fullscreen) */
    var vids=[].slice.call(root.querySelectorAll('#stack video')); if(!vids.length) return;
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){
      if(e.isIntersecting){ e.target.play().catch(function(){}); } else { e.target.pause(); }
    }); },{threshold:.12});
    vids.forEach(function(v){ io.observe(v); });
  })();

  /* ░░ FILL + DISSECTION (una sola pantalla) — ilumina → negro (gota se va) → el texto se PARTE y de ahí EMERGE el despiece desde el fondo → scrub ░░ */
  (function(){
    var fill=root.querySelector('#fill'); if(!fill) return;
    var bg=fill.querySelector('.fill-bg'), stage=fill.querySelector('#fillStage'), drop=fill.querySelector('.fill-drop');
    var ps=[].slice.call(fill.querySelectorAll('.fill-p'));
    var H=fill.querySelector('#dissH'), prod=fill.querySelector('#dissProd'),
        dlA=fill.querySelector('#dlA'), dlB=fill.querySelector('#dlB'), dlC=fill.querySelector('#dlC'),
        dlhA=fill.querySelector('#dlhA'), dlhC=fill.querySelector('#dlhC'),
        coA=fill.querySelector('#coA'), coB=fill.querySelector('#coB'), coC=fill.querySelector('#coC'),
        coT=fill.querySelector('#coT'), countEl=fill.querySelector('#dissCount'),
        dissLayer=fill.querySelector('#dissLayer');
    var ghost=null;   // copia para partir el despiece en dos mitades al salir
    var sets=ps.map(function(p){
      p.innerHTML=p.textContent.split(' ').map(function(w){ return '<span class="w">'+w+'</span>'; }).join(' ');
      return p.querySelectorAll('.w');
    });
    var a=ps[0], b=ps[1], total=sets[0].length;
    function cl(v){ return Math.max(0,Math.min(1,v)); }
    function win(p,x,y){ return cl((p-x)/(y-x)); }
    function ease(t){ return 1-Math.pow(1-t,3); }                  /* easeOutCubic */
    function mix(u,v,t){ return Math.round(u+(v-u)*t); }
    var lastN=-1, raf=null;
    function upd(){ raf=null;
      var r=fill.getBoundingClientRect(), span=fill.offsetHeight-innerHeight;
      var p=cl(-r.top/(span||1));
      /* 1 — iluminación palabra×palabra (sobre claro) */
      var n=Math.floor(win(p,.02,.22)*total);
      if(n!==lastN){ sets.forEach(function(ws){ for(var i=0;i<ws.length;i++) ws[i].classList.toggle('on', i<n); }); lastN=n; }
      /* 2 — fondo negro + letras blancas + la gota se va */
      var blk=ease(win(p,.22,.33));
      bg.style.opacity=blk;
      if(drop) drop.style.opacity=(1-blk).toFixed(3);
      stage.style.setProperty('--won','rgb('+mix(21,255,blk)+','+mix(21,255,blk)+','+mix(26,255,blk)+')');
      stage.style.setProperty('--woff','rgba('+mix(26,235,blk)+','+mix(26,235,blk)+','+mix(28,235,blk)+',.2)');
      /* 3 — el texto se PARTE y de ahí mismo EMERGE el despiece desde el fondo (a la vez) */
      var sp=ease(win(p,.34,.50)), dx=(sp*64).toFixed(2);
      a.style.transform='translate3d(-'+dx+'vw,0,0)';
      b.style.transform='translate3d('+dx+'vw,0,0)';
      stage.style.opacity=(1-win(p,.40,.52)).toFixed(3);
      var ph=win(p,.34,.50); H.style.opacity=ph.toFixed(3); H.style.transform='translateY('+((1-ph)*48).toFixed(1)+'px) scale('+(0.86+ph*0.14).toFixed(4)+')'; H.style.filter='blur('+((1-ph)*8).toFixed(2)+'px)';
      var pp=win(p,.38,.56); prod.style.opacity=pp.toFixed(3); prod.style.transform='translateX(-50%) translateY('+((1-pp)*52).toFixed(1)+'px) scale('+(0.62+pp*0.38).toFixed(4)+')'; prod.style.filter='blur('+((1-pp)*10).toFixed(2)+'px)';
      /* 4 — scrub: líneas se trazan + callouts + 99% + trust */
      dlC.style.transform='scaleY('+win(p,.50,.57)+')'; if(dlhC) dlhC.style.transform='scaleX('+win(p,.55,.62)+')'; var pc=win(p,.55,.62); coC.style.opacity=pc; coC.style.transform='translateY('+(1-pc)*12+'px)';
      dlA.style.transform='scaleY('+win(p,.57,.64)+')'; if(dlhA) dlhA.style.transform='scaleX('+win(p,.62,.69)+')'; var pa=win(p,.62,.69); coA.style.opacity=pa; coA.style.transform='translateY('+(1-pa)*12+'px)';
      dlB.style.transform='scaleY('+win(p,.64,.72)+')'; var pb=win(p,.70,.78); coB.style.opacity=pb; coB.style.transform='translateX(-50%) translateY('+(1-pb)*12+'px)';
      /* Contador SIEMPRE termina en 99: count-up por tiempo (one-shot al entrar), no scrub de scroll — el claim no depende de cuánto scrollees */
      if(countEl && !countEl._agcDone && win(p,.70,.85)>0){
        countEl._agcDone=true;
        (function(){ var t0=null;
          function tick(ts){ if(t0===null) t0=ts; var k=Math.min(1,(ts-t0)/900);
            countEl.textContent=Math.round((1-Math.pow(1-k,3))*99);
            if(k<1) requestAnimationFrame(tick); }
          requestAnimationFrame(tick);
        })();
      }
      coT.style.opacity=win(p,.84,.91);
      /* 5 — al final el despiece (ya ensamblado) se PARTE en dos y se va a los lados, como el texto */
      var sx=ease(win(p,.88,1));
      if(sx>0 && dissLayer){
        if(!ghost){ ghost=dissLayer.cloneNode(true); ghost.className='diss-layer diss-ghost'; ghost.removeAttribute('id');
          var ids=ghost.querySelectorAll('[id]'); for(var gi=0;gi<ids.length;gi++) ids[gi].removeAttribute('id');
          dissLayer.parentNode.appendChild(ghost); }
        var sdx=(sx*56).toFixed(2);
        dissLayer.style.webkitClipPath='inset(0 50% 0 0)'; dissLayer.style.clipPath='inset(0 50% 0 0)'; dissLayer.style.transform='translateX(-'+sdx+'vw)';
        ghost.style.webkitClipPath='inset(0 0 0 50%)'; ghost.style.clipPath='inset(0 0 0 50%)'; ghost.style.transform='translateX('+sdx+'vw)';
      } else if(ghost){
        ghost.remove(); ghost=null;
        dissLayer.style.clipPath=''; dissLayer.style.webkitClipPath=''; dissLayer.style.transform='';
      }
    }
    SCEL.addEventListener('scroll',function(){ if(!raf) raf=requestAnimationFrame(upd); },{passive:true});
    addEventListener('resize',function(){ if(!raf) raf=requestAnimationFrame(upd); });
    upd();
  })();

  /* ░░ PRODUCT ISLANDS — visibles SOLO en el above-the-fold (intro del agua), se ocultan al scrollear ░░ */
  (function(){
    var isla=root.querySelector('.agc-isla'); if(!isla) return;
    var intro=root.querySelector('#intro');
    var mq=matchMedia('(min-width:820px)'), iraf=null;
    function ivis(){ iraf=null;
      var th = mq.matches ? (intro?intro.offsetHeight*0.55:innerHeight*0.55) : 24;  /* mobile: el 1er scroll las oculta */
      isla.classList.toggle('show', SCY() < th);
    }
    SCEL.addEventListener('scroll',function(){ if(!iraf) iraf=requestAnimationFrame(ivis); },{passive:true});
    addEventListener('resize',function(){ if(!iraf) iraf=requestAnimationFrame(ivis); });
    ivis();
    /* sync de dots del slider mobile */
    var track=isla.querySelector('[data-isla-track]'), dots=[].slice.call(isla.querySelectorAll('[data-isla-dots] i'));
    if(track && dots.length){
      track.addEventListener('scroll',function(){
        var cw=(track.firstElementChild?track.firstElementChild.offsetWidth:track.clientWidth)+11;
        var i=Math.max(0,Math.min(dots.length-1,Math.round(track.scrollLeft/cw)));
        dots.forEach(function(d,j){ d.classList.toggle('on', j===i); });
      },{passive:true});
    }
  })();

})();
